export default "__VITE_ASSET__D85OhPJs__"